import isEqual from 'lodash/isEqual'

import { DEVICE_TYPES } from '../constants'

export const isHiddenOnAllDevices = ({ devices = [] }) => {
  return isEqual(devices, Object.values(DEVICE_TYPES))
}
